import * as React from "react"
import { Link, useStaticQuery, graphql } from "gatsby"

import Layout from "../components/layout"
import SEO from "../components/seo"

const LegalNoticePage = () => {
  const data = useStaticQuery(graphql`
    query {
      markdownRemark(frontmatter: { slug: { eq: "mentions-legales" } }) {
        html
      }
    }
  `)
  const {
    markdownRemark: { html },
  } = data
  return (
    <Layout>
      <SEO title="Mentions Légales" />
      <div style={{ background: "#000000a3", padding: "15px" }}>
        <h1>Mentions Légales</h1>
        <div
          className="blog-post-content"
          dangerouslySetInnerHTML={{ __html: html }}
        />
        <Link to="/">Retour à l'accueil</Link>
      </div>
    </Layout>
  )
}
export default LegalNoticePage
